import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IResponse } from '../../models/iresponse';
import { Customers } from '../../models/customers';



@Injectable({
  providedIn: 'root'
})
export class CustomerAccountService {

  API_URLAddUpdateCustomer= `${environment.apiUrl}/CustomerAccount/AddUpdateCustomer`;
  API_URLUpdateCustomer= `${environment.apiUrl}/CustomerAccount/UpdateCustomer`;
  API_URLGetCustomers= `${environment.apiUrl}/CustomerAccount/GetCustomers`;
  API_URLGetCustomersAdmin= `${environment.apiUrl}/CustomerAccount/GetCustomersAdmin`;
  API_URLAddRemoveCustomersToAParent= `${environment.apiUrl}/CustomerAccount/AddRemoveCustomersToAParent`;

  constructor(private http:HttpClient) {}

  AddUpdateCustomer(body:any): Observable<any> {
    const url = this.API_URLAddUpdateCustomer;
    return this.http.post<any>(url,body);
  }
  
  UpdateCustomer(body:any): Observable<any> {
    const url = this.API_URLUpdateCustomer;
    return this.http.post<any>(url,body);
  }

  GetCustomers(body:any): Observable<IResponse<Customers>> {
    const url = this.API_URLGetCustomers;
    return this.http.post<IResponse<Customers>>(url,body);
  }

  // custom api made only to get 3~4 specific users from backend
  GetCustomersAdmin(body:any): Observable<IResponse<Customers>> {
    const url = this.API_URLGetCustomersAdmin;
    return this.http.post<IResponse<Customers>>(url,body);
  }

  AddRemoveCustomersToAParent(body:any): Observable<any> {
    const url = this.API_URLAddRemoveCustomersToAParent;
    return this.http.post<any>(url,body);
  }
}
